"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.AlreadyConfirmed = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const openapi_1 = require("../../../openapi");
const Privacy = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Privacy.Spec';
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Privacy request accepted',
});
exports.AlreadyConfirmed = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.AlreadyConfirmed`, 'PRIVACY_REQUEST_ALREADY_CONFIRMED', 'Privacy Request Already Confirmed', 'The privacy request has any status other than pending, for example processing after an export confirm or fulfilled after an erasure. Carries no express-validator field errors.');
const createRequest = platform_1.HttpApiEndpoint.post('createRequest') `/request`
    .setPayload(Privacy.CreateRequestPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Privacy Request')
    .annotate(platform_1.OpenApi.Description, 'Creates a privacy request (data export or erasure) and emails a confirmation link to the given address. The request is stored and answered the same way whether or not the email belongs to a user. An appId that is not a registered, enabled client application is a 422. Any failure, including a confirmation email that could not be sent, is answered with 500.')
    .pipe(openapi_1.Error.withV1PublicErrors);
const confirmRequest = platform_1.HttpApiEndpoint.post('confirmRequest') `/request/confirm`
    .setPayload(Privacy.ConfirmRequestPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.AlreadyConfirmed)
    .annotate(platform_1.OpenApi.Title, 'Confirm Privacy Request')
    .annotate(platform_1.OpenApi.Description, 'Confirms a pending privacy request. A dataExport request is set to processing and submitted to Customer Care by email; if that email cannot be sent the answer is 500, and the request stays processing, so a retry is a 422. A dataErasure request deletes the user account immediately and is marked fulfilled; it also succeeds when the email has no account. If the deletion fails the answer is 500 and the request stays pending, so it can be retried. Confirming a request in any status other than pending is a 422 with PRIVACY_REQUEST_ALREADY_CONFIRMED. Any other failure, including an unknown id (PRIVACY_REQUEST_NOT_FOUND inside the service), is answered with 500.')
    .pipe(openapi_1.Error.withV1PublicErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.frontend.privacy')
    .add(createRequest)
    .add(confirmRequest)
    .prefix('/user/privacy')
    .annotate(platform_1.OpenApi.Title, 'Privacy')
    .annotate(platform_1.OpenApi.Description, 'Public privacy request endpoints (data export and erasure)')
    .pipe(openapi_1.Security.Public, openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map